/**
 * Add Mouseover Gallery functionality
 *
 * @see https://codepen.io/tcmulder/pen/eYrPKOq
 */
import throttle from '../../util/throttle';

document.querySelectorAll('.js-mouseover-gallery')?.forEach((gallery) => {
	// get the inner dom nodes
	const inner = gallery.querySelector('.js-mouseover-gallery-inner');
	const items = gallery.querySelectorAll('.js-mouseover-gallery-item');
	// get widths of combined children within parent (note: it changes on hover)
	const getChildWidth = () =>
		[...items].reduce((prev, cur) => prev + cur.offsetWidth, 0);
	// handle moving of the gallery
	const move = (percent) => {
		const shift = percent * (getChildWidth() - gallery.offsetWidth) * -1;
		inner.style.setProperty('--shift', `${shift}px`);
	};
	// maybe move to the center on page load
	const isCentered = gallery.dataset.align === 'center';
	isCentered && move(0.5);
	// handle mousemove event
	const moving = throttle((e) => {
		const gutter =
			window.innerWidth > gallery.offsetWidth
				? (window.innerWidth - gallery.offsetWidth) / 2
				: 0;
		const percent = (e.clientX - gutter) / gallery.offsetWidth;
		move(percent);
	}, 50);
	gallery.addEventListener('mousemove', moving);
	// re-center on resize
	const sizing = () => throttle(move(0.5), 100);
	isCentered && window.addEventListener('resize', sizing);
	// disable mousemove if using touch events
	const touching = () => {
		unbind();
		gallery.classList.add('mouseover-gallery--scrollable');
		gallery.scroll({
			left: (getChildWidth() - window.innerWidth) / 2,
		});
	};
	gallery.addEventListener('touchstart', touching);
	// disable mousemove upon keyboard request
	gallery
		.querySelector('.js-mouseover-gallery-scroll')
		.addEventListener('click', function () {
			unbind();
			gallery.classList.add('mouseover-gallery--scrollable');
			inner.setAttribute('tabindex', 0);
			inner.focus();
			this.remove();
		});
	// unbind event listeners (i.e. use touch/keyboard)
	const unbind = () => {
		gallery.removeEventListener('mousemove', moving);
		gallery.removeEventListener('touchstart', touching);
		isCentered && window.removeEventListener('resize', sizing);
	};

	/**
	 * Customizations to normal Mouseover Gallery
	 */
	// add filtering
	const filters = gallery?.previousElementSibling
		?.querySelectorAll('button')
		?.forEach((filter) => {
			filter.addEventListener('click', () => {
				filter.blur();
				move(0);
				gallery.classList.add('adjusting');
				items.forEach((item) => {
					item.classList.toggle(
						'inactive',
						(item.dataset.ids
							? item.dataset.ids.split(',')
							: []
						).includes(filter.dataset.id)
					);
				});
				setTimeout(() => {
					move(0.5);
					gallery.classList.remove('adjusting');
				}, 600);
			});
		});
});
